import React from 'react';
import { Button, Card, Flex, Form, Input, Space, theme } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

const Desktop = ({ viewModel }) => {
  const { token } = theme.useToken();
  const { loginError, onFinish, goToResetPassword } = viewModel;

  return (
    <Card style={{ width: '500px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Flex vertical gap={14}>
        <Space direction='vertical' align='center'>
          <img width={200} style={{ borderRadius: '8px' }} src='https://storage.googleapis.com/cubebio/default/siprologo.png' />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Welcome back!</span>
          <span>Log in to your account</span>
        </Space>

        <Form layout='vertical' initialValues={{}} onFinish={onFinish}>
          <Form.Item
            label='Số điện thoại'
            name='email'
            validateTrigger='onBlur'
            rules={[{ required: true, message: 'Bạn phải nhập số điện thoại' }]}
          >
            <Input placeholder='Số điện thoại' />
          </Form.Item>

          <Form.Item
            label='Password'
            name='pass'
            rules={[{ required: true, message: 'Password is required' }]}
          >
            <Input.Password placeholder='Password' iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Space direction='vertical' style={{ width: '100%' }} size='large'>
            {loginError && (
              <div style={{ float: 'right' }}>
                <span style={{ color: token.colorErrorText }}>{loginError.message}</span>
              </div>
            )}

            <div style={{ float: 'right' }}>
              <Button size='small' type='link' onClick={goToResetPassword}>
                Forgot password?
              </Button>
            </div>

            <Button htmlType='submit' type='primary' style={{ width: '100%' }}>
              Đăng nhập
            </Button>
          </Space>
        </Form>
      </Flex>
    </Card>
  );
};

export default Desktop;
